import generateUtilityClass from '@mui/utils/generateUtilityClass';
import generateUtilityClasses from '@mui/utils/generateUtilityClasses';
import composeClasses from '@mui/utils/composeClasses';
export function getChatComposerUtilityClass(slot) {
  return generateUtilityClass('MuiChatComposer', slot);
}
export const chatComposerClasses = generateUtilityClasses('MuiChatComposer', ['root', 'disabled', 'label', 'textArea', 'sendButton', 'attachButton', 'toolbar', 'attachmentList', 'helperText', 'variantCompact']);
const slots = {
  root: ['root'],
  disabled: ['disabled'],
  label: ['label'],
  textArea: ['textArea'],
  sendButton: ['sendButton'],
  attachButton: ['attachButton'],
  toolbar: ['toolbar'],
  attachmentList: ['attachmentList'],
  helperText: ['helperText'],
  variantCompact: ['variantCompact']
};
export const useChatComposerUtilityClasses = classes => composeClasses(slots, getChatComposerUtilityClass, classes);